(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chilai-hero-slider"] && !Shopify.designMode) return;
  try {
    
  class ChilaiHeroSlider extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this._slides = Array.from(this.querySelectorAll('[data-chilai-slide-index]'));
      this._backgrounds = Array.from(this.querySelectorAll('[data-chilai-background-index]'));
      this._dots = Array.from(this.querySelectorAll('[data-chilai-dot-index]'));
      this._track = this.querySelector('.chilai-hero-slider__track');
      this._prevBtn = this.querySelector('.chilai-hero-slider__btn--prev');
      this._nextBtn = this.querySelector('.chilai-hero-slider__btn--next');
      this._currentIndex = 0;
      this._isAnimating = false;
      this._mobileQuery = window.matchMedia('(max-width: 749px)');

      if (this._slides.length <= 1) return;

      this._prevBtn?.addEventListener('click', () => this._showSlide(this._currentIndex - 1));
      this._nextBtn?.addEventListener('click', () => this._showSlide(this._currentIndex + 1));
      this._dots.forEach((dot, i) => dot.addEventListener('click', () => this._showSlide(i)));
      this._setupTouchNavigation();

      const autoplaySeconds = parseInt(this.dataset.autoplay || '0', 10);
      if (autoplaySeconds > 0) {
        this._startAutoplay(autoplaySeconds);
        this.addEventListener('mouseenter', () => this._stopAutoplay());
        this.addEventListener('mouseleave', () => this._startAutoplay(autoplaySeconds));
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this._stopAutoplay();
          } else {
            this._startAutoplay(autoplaySeconds);
          }
        });
      }
    }

    _showSlide(nextIndex) {
      if (this._isAnimating) return;
      this._isAnimating = true;

      const count = this._slides.length;
      this._currentIndex = ((nextIndex % count) + count) % count;

      this._slides.forEach((slide, i) => {
        if (i === this._currentIndex) {
          slide.setAttribute('data-active', 'true');
        } else {
          slide.removeAttribute('data-active');
        }
      });

      this._dots.forEach((dot, i) => {
        if (i === this._currentIndex) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      this._backgrounds.forEach((background, i) => {
        if (i === this._currentIndex) {
          background.setAttribute('data-active', 'true');
        } else {
          background.removeAttribute('data-active');
        }
      });

      setTimeout(() => {
        this._isAnimating = false;
      }, 650);
    }

    _setupTouchNavigation() {
      if (!this._track) return;

      this._track.addEventListener('touchstart', (event) => this._handleTouchStart(event), { passive: true });
      this._track.addEventListener('touchend', (event) => this._handleTouchEnd(event), { passive: false });
      this._track.addEventListener('touchcancel', () => this._resetTouch(), { passive: true });
      this._track.addEventListener(
        'click',
        (event) => {
          if (!this._suppressClick) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this._suppressClick = false;
        },
        true
      );
    }

    _handleTouchStart(event) {
      if (!this._mobileQuery.matches) return;

      const touch = event.touches[0];
      this._touchStartX = touch.clientX;
      this._touchStartY = touch.clientY;
    }

    _handleTouchEnd(event) {
      if (!this._mobileQuery.matches) return;
      if (this._touchStartX === undefined || this._touchStartY === undefined) return;

      const touch = event.changedTouches[0];
      const deltaX = touch.clientX - this._touchStartX;
      const deltaY = touch.clientY - this._touchStartY;
      const absX = Math.abs(deltaX);
      const absY = Math.abs(deltaY);

      this._resetTouch();

      if (absX < 50 || absX < absY * 1.2) return;

      this._suppressClick = true;
      window.setTimeout(() => {
        this._suppressClick = false;
      }, 350);

      if (event.cancelable) event.preventDefault();
      this._showSlide(this._currentIndex + (deltaX < 0 ? 1 : -1));
    }

    _resetTouch() {
      this._touchStartX = undefined;
      this._touchStartY = undefined;
    }

    _startAutoplay(seconds) {
      this._stopAutoplay();
      this._autoplayTimer = setInterval(() => this._showSlide(this._currentIndex + 1), seconds * 1000);
    }

    _stopAutoplay() {
      clearInterval(this._autoplayTimer);
      this._autoplayTimer = undefined;
    }
  }

  if (!customElements.get('chilai-hero-slider')) {
    customElements.define('chilai-hero-slider', ChilaiHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-bottle-tea-page"]) return;
  try {
    
  function parseMoneyValue(value) {
    if (!value) return null;

    const normalized = String(value).replace(/[^0-9.]/g, '');
    if (!normalized) return null;

    return Number(normalized);
  }

  function formatMoneyValue(value) {
    return `¥${new Intl.NumberFormat('ja-JP').format(value)}`;
  }

  function sortItems(items, sortValue) {
    const collator = new Intl.Collator('ja');

    return [...items].sort((left, right) => {
      const leftIndex = Number(left.dataset.productIndex || 0);
      const rightIndex = Number(right.dataset.productIndex || 0);
      const leftPrice = Number(left.dataset.productPrice || 0);
      const rightPrice = Number(right.dataset.productPrice || 0);
      const leftCreatedAt = Number(left.dataset.productCreatedAt || 0);
      const rightCreatedAt = Number(right.dataset.productCreatedAt || 0);
      const leftTitle = left.dataset.productTitle || '';
      const rightTitle = right.dataset.productTitle || '';

      switch (sortValue) {
        case 'created-desc':
          return rightCreatedAt - leftCreatedAt || leftIndex - rightIndex;
        case 'price-asc':
          return leftPrice - rightPrice || leftIndex - rightIndex;
        case 'price-desc':
          return rightPrice - leftPrice || leftIndex - rightIndex;
        case 'title-asc':
          return collator.compare(leftTitle, rightTitle) || leftIndex - rightIndex;
        default:
          return leftIndex - rightIndex;
      }
    });
  }

  function matchesFilters(item, filters) {
    const available = item.dataset.productAvailable === 'true';
    const price = Number(item.dataset.productPrice || 0);
    const productType = item.dataset.productType || '';

    if (filters.availability === 'in-stock' && available === false) return false;
    if (filters.availability === 'sold-out' && available) return false;

    if (filters.priceMin !== null && price < filters.priceMin * 100) return false;
    if (filters.priceMax !== null && price > filters.priceMax * 100) return false;

    if (filters.categories.length > 0) {
      if (!filters.categories.includes(productType)) return false;
    }

    return true;
  }

  function updateBottleTeaPage(section) {
    const grid = section.querySelector('[data-bottle-grid]');
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll('.product-grid__item'));
    const count = section.querySelector('[data-bottle-count]');
    const availabilityInput = section.querySelector('input[name="bottle_availability"]:checked');
    const priceMinInput = section.querySelector('[data-bottle-price-min]');
    const priceMaxInput = section.querySelector('[data-bottle-price-max]');
    const categoryInputs = Array.from(section.querySelectorAll('input[name="bottle_category"]:checked'));
    const sortInput = section.querySelector('input[name="bottle_sort"]:checked');

    if (!availabilityInput || !priceMinInput || !priceMaxInput || !sortInput) return;

    const filters = {
      availability: availabilityInput.value,
      priceMin: parseMoneyValue(priceMinInput.value),
      priceMax: parseMoneyValue(priceMaxInput.value),
      categories: categoryInputs.map((input) => input.value)
    };

    const sortedItems = sortItems(items, sortInput.value);
    let visibleCount = 0;

    for (const item of sortedItems) {
      const isVisible = matchesFilters(item, filters);
      item.hidden = !isVisible;

      if (isVisible) {
        visibleCount += 1;
      }

      grid.appendChild(item);
    }

    if (count) {
      count.textContent = `${visibleCount}個のアイテム`;
    }

    const availabilityStatus = section.querySelector('[data-bottle-status-availability]');
    const priceStatus = section.querySelector('[data-bottle-status-price]');
    const categoryStatus = section.querySelector('[data-bottle-status-category]');
    const sortStatus = section.querySelector('[data-bottle-sort-status]');

    if (availabilityStatus) {
      availabilityStatus.textContent = availabilityInput.dataset.bottleFilterLabel || '';
    }

    if (priceStatus) {
      if (filters.priceMin !== null || filters.priceMax !== null) {
        const minLabel = filters.priceMin !== null ? formatMoneyValue(filters.priceMin) : formatMoneyValue(0);
        const maxLabel = filters.priceMax !== null ? formatMoneyValue(filters.priceMax) : '';
        priceStatus.textContent = maxLabel ? `${minLabel} - ${maxLabel}` : `${minLabel} -`;
      } else {
        priceStatus.textContent = '';
      }
    }

    if (categoryStatus) {
      if (categoryInputs.length === 1) {
        categoryStatus.textContent = categoryInputs[0].dataset.bottleFilterLabel || '';
      } else if (categoryInputs.length > 1) {
        categoryStatus.textContent = `${categoryInputs.length}`;
      } else {
        categoryStatus.textContent = '';
      }
    }

    if (sortStatus) {
      sortStatus.textContent = sortInput.dataset.bottleSortLabel || 'おすすめ順';
    }
  }

  function initializeBottleTeaPage(section) {
    const controls = section.querySelectorAll(
      '[data-bottle-filter-input], [data-bottle-sort-input], [data-bottle-price-min], [data-bottle-price-max]'
    );

    if (controls.length === 0) return;

    for (const control of controls) {
      control.addEventListener('change', (event) => {
        const currentTarget = event.currentTarget;
        const details = currentTarget.closest('details');

        if (details) {
          const shouldClose =
            currentTarget.matches('[data-bottle-sort-input]') ||
            currentTarget.name === 'bottle_availability';

          if (shouldClose) {
            details.open = false;
          }
        }

        updateBottleTeaPage(section);
      });
    }

    updateBottleTeaPage(section);
  }

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      const sections = document.querySelectorAll('[data-bottle-tea-page]');

      for (const section of sections) {
        initializeBottleTeaPage(section);
      }
    },
    { once: true }
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-gift-page"] && !Shopify.designMode) return;
  try {
    
  class GiftPageSlider extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      const slides = Array.from(this.querySelectorAll('[data-gift-slider-slide]'));
      const dots = Array.from(this.querySelectorAll('[data-gift-slider-dot]'));
      const prevButton = this.querySelector('[data-gift-slider-prev]');
      const nextButton = this.querySelector('[data-gift-slider-next]');

      if (slides.length <= 1) return;

      let currentIndex = slides.findIndex((slide) => slide.dataset.active === 'true');
      if (currentIndex < 0) currentIndex = 0;

      let isAnimating = false;

      const showSlide = (nextIndex) => {
        if (isAnimating) return;
        isAnimating = true;

        currentIndex = (nextIndex + slides.length) % slides.length;

        slides.forEach((slide, index) => {
          if (index === currentIndex) {
            slide.setAttribute('data-active', 'true');
          } else {
            slide.removeAttribute('data-active');
          }
        });

        dots.forEach((dot, index) => {
          if (index === currentIndex) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });

        setTimeout(() => { isAnimating = false; }, 650);
      };

      prevButton?.addEventListener('click', () => showSlide(currentIndex - 1));
      nextButton?.addEventListener('click', () => showSlide(currentIndex + 1));
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => showSlide(index));
      });
    }
  }

  if (!customElements.get('gift-page-slider')) {
    customElements.define('gift-page-slider', GiftPageSlider);
  }

  function initGiftSortSection(section) {
    const grid = section.querySelector('[data-gift-grid]');
    const sortSelect = section.querySelector('[data-gift-sort]');

    if (!grid) return;

    const sortItems = () => {
      if (!sortSelect) return;

      const items = Array.from(grid.querySelectorAll('.gift-page__products-item'));
      const value = sortSelect.value;

      items.sort((a, b) => {
        switch (value) {
          case 'title-ascending':
            return a.dataset.sortTitle.localeCompare(b.dataset.sortTitle, 'ja');
          case 'price-ascending':
            return Number(a.dataset.sortPrice) - Number(b.dataset.sortPrice);
          case 'price-descending':
            return Number(b.dataset.sortPrice) - Number(a.dataset.sortPrice);
          case 'created-descending':
            return Number(b.dataset.sortCreated) - Number(a.dataset.sortCreated);
          default:
            return Number(a.dataset.sortManual) - Number(b.dataset.sortManual);
        }
      });

      for (const item of items) {
        grid.appendChild(item);
      }
    };

    sortSelect?.addEventListener('change', sortItems);
  }

  function initAllGiftSortSections() {
    document.querySelectorAll('.gift-page-section').forEach(initGiftSortSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllGiftSortSections);
  } else {
    initAllGiftSortSections();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.gift-page-section');
    if (section) initGiftSortSection(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  (() => {
    const PRODUCT_INFORMATION_SELECTOR = '[data-testid="product-information"]';
    const INFINITE_OPTIONS_SELECTOR = '#infiniteoptions-container';
    const GIFT_PAIRING_SELECTOR = '[data-gift-pairing-selector]';
    const QUANTITY_INPUT_SELECTOR = 'input[name="quantity"], input[type="number"][id*="quantity"]';
    const REQUIRED_BADGE_CLASS = 'chilai-required-badge';
    let scheduled = false;
    let giftPairingUpdateTimer = null;
    let headerCartUnlockTimer = null;

    function translateAlertMessage(message) {
      if (typeof message !== 'string') return message;

      const exactMap = {
        'Please add your personalized text before adding this item to cart.':
          'カートに追加する前に、メッセージ内容をご入力ください。',
      };

      if (exactMap[message]) return exactMap[message];

      return message
        .replace(
          /Please add your personalized text before adding this item to cart\./gi,
          'カートに追加する前に、メッセージ内容をご入力ください。'
        )
        .replace(/This field is required\./gi, 'この項目は必須です。')
        .replace(/Please select an option\./gi, '項目を選択してください。');
    }

    if (window.__chilaiAlertTranslationInit !== true) {
      window.__chilaiAlertTranslationInit = true;

      const originalAlert = window.alert.bind(window);
      window.alert = (message) => {
        originalAlert(translateAlertMessage(message));
      };
    }

    function getLabelText(radio) {
      const label = radio.closest('label') || document.querySelector(`label[for="${radio.id}"]`);
      return label ? label.textContent || '' : '';
    }

    function getTwoBottleGiftBoxRadios(scope) {
      return Array.from(scope.querySelectorAll('input[type="radio"]')).filter((radio) =>
        getLabelText(radio).includes('2本箱')
      );
    }

    function getCurrentProductVariantId(section) {
      const variantInput = section.querySelector(
        'product-form-component input[name="id"], form[action*="/cart/add"] input[name="id"]'
      );

      return variantInput instanceof HTMLInputElement ? variantInput.value : '';
    }

    function getSelectedGiftBox(section, selector) {
      const selectedRadio = Array.from(section.querySelectorAll('input[type="radio"]')).find((radio) => {
        if (!radio.checked) return false;

        return getLabelText(radio).includes('本箱');
      });
      const selectedLabel = selectedRadio ? getLabelText(selectedRadio) : '';

      if (selectedLabel.includes('2本箱')) {
        return {
          type: 'two',
          title: '2本箱',
          variantId: selector?.dataset.giftBoxVariantId || '',
        };
      }

      if (selectedLabel.includes('1本箱')) {
        const currentVariantId = getCurrentProductVariantId(section);
        const freeOneBottleTriggerVariantId = selector?.dataset.giftBoxFreeOneBottleTriggerVariantId || '';
        const freeOneBottleVariantId = selector?.dataset.giftBoxFreeOneBottleVariantId || '';
        const oneBottleVariantId =
          currentVariantId === freeOneBottleTriggerVariantId && freeOneBottleVariantId
            ? freeOneBottleVariantId
            : selector?.dataset.giftBoxOneBottleVariantId || '';

        return {
          type: 'one',
          title: '1本箱',
          variantId: oneBottleVariantId,
        };
      }

      return { type: '', title: '', variantId: '' };
    }

    function updateGiftBoxHelpText(section) {
      const container = section.querySelector(INFINITE_OPTIONS_SELECTOR);

      if (!(container instanceof HTMLElement)) return;

      Array.from(container.querySelectorAll('.spb-helptext, .help-text, .option-help, small, p')).forEach((element) => {
        const text = element.textContent || '';

        if (text.includes('2本以上ご購入の場合は2本箱をお選びください')) {
          element.textContent = '2本箱をご希望の場合は、組み合わせを指定できます。';
        }
      });
    }

    function placeGiftPairingSelector(section) {
      const container = section.querySelector(INFINITE_OPTIONS_SELECTOR);
      const selector = document.querySelector(GIFT_PAIRING_SELECTOR);

      if (!(container instanceof HTMLElement) || !(selector instanceof HTMLElement)) return selector;

      const helpText = Array.from(container.querySelectorAll('.spb-helptext, .help-text, .option-help, small, p')).find(
        (element) => (element.textContent || '').includes('2本箱をご希望の場合は、組み合わせを指定できます。')
      );

      if (helpText instanceof HTMLElement) {
        if (selector.previousElementSibling !== helpText) {
          helpText.insertAdjacentElement('afterend', selector);
        }
      } else if (selector.previousElementSibling !== container) {
        container.insertAdjacentElement('afterend', selector);
      }

      return selector;
    }

    function updateGiftPairingSelector(section) {
      const selector = placeGiftPairingSelector(section);

      if (!(selector instanceof HTMLElement)) return;

      const inputs = Array.from(selector.querySelectorAll('[data-gift-pairing-input]'));
      const twoBottleSelected = getTwoBottleGiftBoxRadios(section).some((radio) => radio.checked);

      selector.hidden = !twoBottleSelected;
      selector.setAttribute('aria-hidden', String(!twoBottleSelected));

      if (twoBottleSelected) {
        section.setAttribute('data-gift-pairing-active', 'true');
      } else {
        section.removeAttribute('data-gift-pairing-active');
      }

      inputs.forEach((input) => {
        if (!(input instanceof HTMLInputElement)) return;

        input.disabled = !twoBottleSelected;
        input.required = twoBottleSelected;

        if (!twoBottleSelected) {
          input.checked = false;
        }
      });

      updateGiftPairingCalculation(selector);
    }

    function formatTaxIncludedPrice(price) {
      return `${new Intl.NumberFormat('ja-JP', {
        style: 'currency',
        currency: 'JPY',
        maximumFractionDigits: 0,
      }).format(price / 100)} 税込`;
    }

    function formatPrice(price) {
      return new Intl.NumberFormat('ja-JP', {
        style: 'currency',
        currency: 'JPY',
        maximumFractionDigits: 0,
      }).format(price / 100);
    }

    function getSetQuantity(selector) {
      const input = selector.querySelector('[data-gift-pairing-set-quantity]');
      return Math.max(parseInt(input?.value || '1', 10), 1);
    }

    function getFormQuantity(form) {
      const input = form?.querySelector('input[name="quantity"]');
      return Math.max(parseInt(input?.value || '1', 10), 1);
    }

    function getMatchingGiftSet(selector, selectedInput) {
      const currentHandle = selector.dataset.currentProductHandle;
      const selectedHandle = selectedInput?.dataset.productHandle;

      if (!currentHandle || !selectedHandle) return null;

      const key = `${currentHandle}|${selectedHandle}`;
      const reverseKey = `${selectedHandle}|${currentHandle}`;

      return (
        Array.from(selector.querySelectorAll('[data-gift-set-match]')).find((match) => {
          return (
            match.dataset.giftSetKey === key ||
            match.dataset.giftSetReverseKey === key ||
            match.dataset.giftSetKey === reverseKey ||
            match.dataset.giftSetReverseKey === reverseKey
          );
        }) || null
      );
    }

    function updateGiftPairingCalculation(selector) {
      const summary = selector.querySelector('[data-gift-pairing-summary]');
      const selectedInput = selector.querySelector('[data-gift-pairing-input]:checked');

      if (!(summary instanceof HTMLElement)) return;

      if (!(selectedInput instanceof HTMLInputElement)) {
        summary.hidden = true;
        return;
      }

      const setQty = getSetQuantity(selector);
      const currentPrice = Number(selector.dataset.currentProductPrice || 0);
      const currentTaxMultiplier = Number(selector.dataset.currentProductTaxMultiplier || 1.08);
      const selectedPrice = Number(selectedInput.dataset.productPrice || 0);
      const selectedTaxMultiplier = Number(selectedInput.dataset.productTaxMultiplier || 1.08);
      const giftBoxPrice = Number(selector.dataset.giftBoxPrice || 0);
      const matchingGiftSet = getMatchingGiftSet(selector, selectedInput);
      const giftSetPrice = Number(matchingGiftSet?.dataset.giftSetPrice || 0);
      const currentPriceTaxIncluded = Math.round(currentPrice * currentTaxMultiplier);
      const selectedPriceTaxIncluded = Math.round(selectedPrice * selectedTaxMultiplier);
      const giftBoxPriceTaxIncluded = Math.round(giftBoxPrice * 1.1);
      const giftSetPriceTaxIncluded = Math.round(giftSetPrice * 1.08);
      const total = matchingGiftSet
        ? giftSetPriceTaxIncluded * setQty
        : (currentPriceTaxIncluded + selectedPriceTaxIncluded + giftBoxPriceTaxIncluded) * setQty;

      const currentRow = summary.querySelector('[data-gift-pairing-current-row]');
      const selectedRow = summary.querySelector('[data-gift-pairing-selected-row]');
      const boxRow = summary.querySelector('[data-gift-pairing-box-row]');
      const currentTitleEl = summary.querySelector('[data-gift-pairing-current-title]');
      const currentPriceEl = summary.querySelector('[data-gift-pairing-current-price]');
      const selectedTitleEl = summary.querySelector('[data-gift-pairing-selected-title]');
      const selectedPriceEl = summary.querySelector('[data-gift-pairing-selected-price]');
      const boxPriceEl = summary.querySelector('[data-gift-pairing-box-price]');
      const totalEl = summary.querySelector('[data-gift-pairing-total]');
      const currentQtyEl = summary.querySelector('[data-gift-pairing-current-qty]');
      const selectedQtyEl = summary.querySelector('[data-gift-pairing-selected-qty]');
      const boxQtyEl = summary.querySelector('[data-gift-pairing-box-qty]');
      const giftSetNoteEl = summary.querySelector('[data-gift-pairing-gift-set-note]');

      if (currentRow instanceof HTMLElement) currentRow.hidden = false;
      if (selectedRow instanceof HTMLElement) selectedRow.hidden = Boolean(matchingGiftSet);
      if (boxRow instanceof HTMLElement) boxRow.hidden = Boolean(matchingGiftSet);

      if (currentTitleEl) {
        currentTitleEl.textContent = matchingGiftSet?.dataset.giftSetTitle || selector.dataset.currentProductTitle || '';
      }
      if (currentPriceEl) {
        currentPriceEl.textContent = matchingGiftSet
          ? formatTaxIncludedPrice(giftSetPriceTaxIncluded)
          : formatTaxIncludedPrice(currentPriceTaxIncluded);
      }
      if (selectedTitleEl) selectedTitleEl.textContent = selectedInput.dataset.productTitle || selectedInput.value;
      if (selectedPriceEl) selectedPriceEl.textContent = formatTaxIncludedPrice(selectedPriceTaxIncluded);
      if (boxPriceEl) boxPriceEl.textContent = formatTaxIncludedPrice(giftBoxPriceTaxIncluded);
      if (giftSetNoteEl instanceof HTMLElement) giftSetNoteEl.hidden = !matchingGiftSet;

      if (totalEl) totalEl.textContent = formatTaxIncludedPrice(total);
      if (currentQtyEl) currentQtyEl.textContent = `×${setQty}`;
      if (selectedQtyEl) selectedQtyEl.textContent = `×${setQty}`;
      if (boxQtyEl) boxQtyEl.textContent = `×${setQty}`;

      summary.hidden = false;
    }

    function getGiftPairingActionButtons(section) {
      return Array.from(
        section.querySelectorAll('button[name="add"][type="submit"], .shopify-payment-button__button')
      ).filter((button) => button instanceof HTMLButtonElement);
    }

    function setGiftPairingButtonsPending(section, isPending) {
      getGiftPairingActionButtons(section).forEach((button) => {
        if (isPending) {
          if (button.dataset.giftPairingPending !== 'true') {
            button.dataset.giftPairingWasDisabled = button.disabled ? 'true' : 'false';
          }

          button.dataset.giftPairingPending = 'true';
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
        } else if (button.dataset.giftPairingPending === 'true') {
          const wasDisabled = button.dataset.giftPairingWasDisabled === 'true';
          delete button.dataset.giftPairingPending;
          delete button.dataset.giftPairingWasDisabled;
          button.disabled = wasDisabled;
          button.removeAttribute('aria-busy');
        }
      });
    }

    function queueGiftPairingReady(section, delay = 120) {
      window.clearTimeout(giftPairingUpdateTimer);
      setGiftPairingButtonsPending(section, true);

      giftPairingUpdateTimer = window.setTimeout(() => {
        updateSection(section);
        setGiftPairingButtonsPending(section, false);
      }, delay);
    }

    function getHeaderCartTriggers() {
      return Array.from(document.querySelectorAll('[data-testid="cart-drawer-trigger"], a.action__cart'));
    }

    function setHeaderCartLocked(isLocked, duration = 1800) {
      window.clearTimeout(headerCartUnlockTimer);

      getHeaderCartTriggers().forEach((trigger) => {
        if (!(trigger instanceof HTMLElement)) return;

        if (isLocked) {
          if (trigger.dataset.chilaiCartLocked !== 'true') {
            trigger.dataset.chilaiCartWasDisabled =
              trigger instanceof HTMLButtonElement && trigger.disabled ? 'true' : 'false';
            trigger.dataset.chilaiCartPreviousTabindex = trigger.getAttribute('tabindex') || '';
            trigger.dataset.chilaiCartPreviousPointerEvents = trigger.style.pointerEvents || '';
          }

          trigger.dataset.chilaiCartLocked = 'true';
          trigger.setAttribute('aria-disabled', 'true');
          trigger.style.pointerEvents = 'none';

          if (trigger instanceof HTMLButtonElement) {
            trigger.disabled = true;
          } else {
            trigger.setAttribute('tabindex', '-1');
          }
        } else if (trigger.dataset.chilaiCartLocked === 'true') {
          const wasDisabled = trigger.dataset.chilaiCartWasDisabled === 'true';
          const previousTabindex = trigger.dataset.chilaiCartPreviousTabindex || '';
          const previousPointerEvents = trigger.dataset.chilaiCartPreviousPointerEvents || '';

          delete trigger.dataset.chilaiCartLocked;
          delete trigger.dataset.chilaiCartWasDisabled;
          delete trigger.dataset.chilaiCartPreviousTabindex;
          delete trigger.dataset.chilaiCartPreviousPointerEvents;
          trigger.removeAttribute('aria-disabled');
          trigger.style.pointerEvents = previousPointerEvents;

          if (trigger instanceof HTMLButtonElement) {
            trigger.disabled = wasDisabled;
          } else if (previousTabindex) {
            trigger.setAttribute('tabindex', previousTabindex);
          } else {
            trigger.removeAttribute('tabindex');
          }
        }
      });

      if (isLocked) {
        headerCartUnlockTimer = window.setTimeout(() => setHeaderCartLocked(false), duration);
      }
    }

    function getLabelForField(field, scope) {
      if (!(field instanceof Element)) return null;

      if (field.closest('label')) return field.closest('label');

      const fieldset = field.closest('fieldset');
      if (fieldset) {
        const legend = fieldset.querySelector('legend, .spb-label-tooltip');
        if (legend) return legend;
      }

      const fieldId = field.getAttribute('id');
      if (fieldId && typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
        const explicitLabel = scope.querySelector(`label[for="${CSS.escape(fieldId)}"]`);
        if (explicitLabel) return explicitLabel;
      }

      const optionGroup = field.closest('div, li, td');
      if (!optionGroup) return null;

      return optionGroup.querySelector(':scope > label, :scope > legend, :scope > .spb-label-tooltip');
    }

    function hasRequiredBadge(label) {
      return Boolean(
        label?.querySelector(
          `.${REQUIRED_BADGE_CLASS}, .required, [class*="required"], [id*="required"], [data-required="true"]`
        )
      );
    }

    function createRequiredBadge() {
      const badge = document.createElement('span');
      badge.className = REQUIRED_BADGE_CLASS;
      badge.setAttribute('aria-label', '必須項目');
      badge.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M11 2h2v7.586l5.293-5.293 1.414 1.414L14.414 11H22v2h-7.586l5.293 5.293-1.414 1.414L13 14.414V22h-2v-7.586l-5.293 5.293-1.414-1.414L9.586 13H2v-2h7.586L4.293 5.707l1.414-1.414L11 9.586V2z"/></svg>必須';
      return badge;
    }

    function isRequiredField(field) {
      if (!(field instanceof HTMLElement)) return false;

      return (
        field.matches('[required], [aria-required="true"], [data-required="true"]') ||
        field.className.toLowerCase().includes('required') ||
        field.id.toLowerCase().includes('required')
      );
    }

    function updateRequiredBadges(section) {
      const container = section.querySelector(INFINITE_OPTIONS_SELECTOR);

      if (!(container instanceof HTMLElement)) return;

      container.querySelectorAll(`.${REQUIRED_BADGE_CLASS}`).forEach((badge) => badge.remove());

      const requiredFields = Array.from(container.querySelectorAll('input, select, textarea')).filter((field) => {
        if (field.closest(GIFT_PAIRING_SELECTOR)) return false;

        return isRequiredField(field);
      });

      requiredFields.forEach((field) => {
        const label = getLabelForField(field, container);

        if (!label || hasRequiredBadge(label)) return;

        label.append(createRequiredBadge());
      });
    }

    function replaceTextInNode(node, search, replacement) {
      node.childNodes.forEach((child) => {
        if (child.nodeType === Node.TEXT_NODE) {
          child.textContent = child.textContent.replace(search, replacement);
          return;
        }

        if (child.nodeType === Node.ELEMENT_NODE) {
          replaceTextInNode(child, search, replacement);
        }
      });
    }

    function updateGiftSetBoxLabel(section) {
      const container = section.querySelector(INFINITE_OPTIONS_SELECTOR);
      const selector = document.querySelector(GIFT_PAIRING_SELECTOR);

      if (!(container instanceof HTMLElement) || !(selector instanceof HTMLElement)) return;

      const selectedInput = selector.querySelector('[data-gift-pairing-input]:checked');
      const isGiftSetMatched = !selector.hidden && Boolean(getMatchingGiftSet(selector, selectedInput));

      Array.from(container.querySelectorAll('label')).forEach((label) => {
        if (!(label.textContent || '').includes('2本箱')) return;

        if (isGiftSetMatched) {
          replaceTextInNode(label, '+¥1,650税込', '無料（ギフトセット）');
          replaceTextInNode(label, '+¥1,650 税込', '無料（ギフトセット）');
          replaceTextInNode(label, '+¥1,500 税抜', '無料（ギフトセット）');
          replaceTextInNode(label, '+¥1,500', '無料（ギフトセット）');
        } else {
          replaceTextInNode(label, '無料（ギフトセット）', '+¥1,500');
          replaceTextInNode(label, '+¥1,650税込', '+¥1,500');
          replaceTextInNode(label, '+¥1,650 税込', '+¥1,500');
          replaceTextInNode(label, '+¥1,500 税抜', '+¥1,500');
        }
      });
    }

    function updateSection(section) {
      updateRequiredBadges(section);
      updateGiftBoxHelpText(section);

      updateGiftPairingSelector(section);
      updateGiftSetBoxLabel(section);
    }

    function updateAllSections() {
      document.querySelectorAll(PRODUCT_INFORMATION_SELECTOR).forEach((section) => updateSection(section));
    }

    function scheduleUpdate() {
      if (scheduled) return;

      scheduled = true;
      window.requestAnimationFrame(() => {
        scheduled = false;
        updateAllSections();
      });
    }

    function handleQuantityEvent(event) {
      const target = event.target;

      if (!(target instanceof Element)) {
        scheduleUpdate();
        return;
      }

      const section = target.closest(PRODUCT_INFORMATION_SELECTOR);
      if (section) {
        updateSection(section);
        return;
      }

      scheduleUpdate();
    }

    // セット数量 +/− ボタン
    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const cartTrigger = target.closest('[data-testid="cart-drawer-trigger"], a.action__cart');
      if (cartTrigger instanceof HTMLElement && cartTrigger.dataset.chilaiCartLocked === 'true') {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      const decreaseBtn = target.closest('[data-gift-pairing-set-decrease]');
      const increaseBtn = target.closest('[data-gift-pairing-set-increase]');
      if (!decreaseBtn && !increaseBtn) return;

      const selector = (decreaseBtn || increaseBtn).closest(GIFT_PAIRING_SELECTOR);
      if (!selector) return;

      const input = selector.querySelector('[data-gift-pairing-set-quantity]');
      if (!(input instanceof HTMLInputElement)) return;

      const current = Math.max(parseInt(input.value, 10) || 1, 1);
      const section = selector.closest(PRODUCT_INFORMATION_SELECTOR);

      if (section) setGiftPairingButtonsPending(section, true);
      input.value = String(decreaseBtn ? Math.max(current - 1, 1) : current + 1);
      updateGiftPairingCalculation(selector);
      if (section) queueGiftPairingReady(section);
    });

    document.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest('button[name="add"][type="submit"]');
        if (!button) return;
        if (button.disabled) return;
        if (!button.closest(PRODUCT_INFORMATION_SELECTOR)) return;

        setHeaderCartLocked(true, 2200);
      },
      true
    );

    // カートに入れる — キャプチャフェーズで先行実行し、セット数量でフォームを上書き
    // 選択商品とギフトボックス商品を現在の商品と同じセット数で追加する。
    document.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest('button[name="add"][type="submit"]');
        if (!button) return;

        const section = button.closest(PRODUCT_INFORMATION_SELECTOR);
        if (!section) return;

        const selector = section.querySelector(GIFT_PAIRING_SELECTOR);
        if (!selector) return;

        const selectedGiftBox = getSelectedGiftBox(section, selector);
        const isTwoBottleBox = selectedGiftBox.type === 'two';

        if (!selectedGiftBox.type) return;

        const selectedInput = selector.querySelector('[data-gift-pairing-input]:checked');
        if (isTwoBottleBox && !selectedInput) {
          window.alert('2本箱に入れるもう1本を選択してください。');
          return;
        }

        const giftBoxVariantId = selectedGiftBox.variantId;

        // product-form-component が FormData を読む前にフォームの quantity を上書き
        const form = button.form || button.closest('form');
        const formQuantityInput = form?.querySelector('input[name="quantity"]');
        const setQty = isTwoBottleBox ? getSetQuantity(selector) : getFormQuantity(form);
        const giftPairingGroup = `gift-pairing-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        if (formQuantityInput) formQuantityInput.value = String(setQty);

        // 対象組み合わせはギフトセット商品として追加し、それ以外は各商品と箱商品を追加する。
        event.preventDefault();
        event.stopImmediatePropagation();

        button.setAttribute('aria-busy', 'true');
        button.disabled = true;

        const formData = new FormData(form);
        formData.set('quantity', String(setQty));
        formData.set('properties[_gift_pairing_group]', giftPairingGroup);
        formData.set('properties[_gift_pairing_role]', 'main');

        const pairingVariantId = isTwoBottleBox ? selectedInput.dataset.variantId : '';
        const currentTitle = selector.dataset.currentProductTitle || '';
        const selectedTitle = isTwoBottleBox ? selectedInput.dataset.productTitle || selectedInput.value || '' : '';
        const matchingGiftSet = isTwoBottleBox ? getMatchingGiftSet(selector, selectedInput) : null;

        if (matchingGiftSet) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({
              items: [
                {
                  id: parseInt(matchingGiftSet.dataset.giftSetVariantId, 10),
                  quantity: setQty,
                  properties: {
                    ギフトセット内容: `${currentTitle} + ${selectedTitle}`,
                    _gift_pairing_group: giftPairingGroup,
                    _gift_pairing_role: 'gift_set',
                  },
                },
              ],
            }),
          })
            .then((res) => {
              if (!res.ok) throw new Error('Add to cart failed');
            })
            .then(() => {
              document.dispatchEvent(
                new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: { data: { source: 'product-form-component', itemCount: setQty } },
                })
              );
              button.removeAttribute('aria-busy');
              button.disabled = false;
              setHeaderCartLocked(true, 1200);
            })
            .catch((error) => {
              console.error(error);
              button.removeAttribute('aria-busy');
              button.disabled = false;
              setHeaderCartLocked(false);
              window.alert('カートへの追加に失敗しました。時間をおいて再度お試しください。');
            });

          return;
        }

        if (!selectedGiftBox.variantId) {
          window.alert('ギフトボックス商品が設定されていません。');
          button.removeAttribute('aria-busy');
          button.disabled = false;
          setHeaderCartLocked(false);
          return;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
        })
          .then((res) => {
            if (!res.ok) throw new Error('Add to cart failed');

            const additions = [];

            if (pairingVariantId) {
              additions.push({
                id: parseInt(pairingVariantId, 10),
                quantity: setQty,
                properties: {
                  '2本箱の組み合わせ商品': currentTitle,
                  _gift_pairing_group: giftPairingGroup,
                  _gift_pairing_role: 'pairing',
                },
              });
            }

            if (giftBoxVariantId && !matchingGiftSet) {
              const giftBoxProperties = {
                _gift_pairing_group: giftPairingGroup,
                _gift_pairing_role: 'gift_box',
              };

              if (isTwoBottleBox) {
                giftBoxProperties['2本箱の組み合わせ商品'] = `${currentTitle} + ${selectedTitle}`;
              }

              additions.push({
                id: parseInt(giftBoxVariantId, 10),
                quantity: setQty,
                properties: giftBoxProperties,
              });
            }

            if (additions.length === 0) return;

            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({ items: additions }),
            }).then((res2) => {
              if (!res2.ok) throw new Error('Add to cart failed');
            });
          })
          .then(() => {
            document.dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: { data: { source: 'product-form-component', itemCount: setQty } },
              })
            );
            button.removeAttribute('aria-busy');
            button.disabled = false;
            setHeaderCartLocked(true, 1200);
          })
          .catch((error) => {
            console.error(error);
            button.removeAttribute('aria-busy');
            button.disabled = false;
            setHeaderCartLocked(false);
            window.alert('カートへの追加に失敗しました。時間をおいて再度お試しください。');
          });
      },
      true
    ); // キャプチャフェーズ: product-form-component のハンドラより先に実行

    // 今すぐ購入 — gift pairing active時: 両商品をカートに追加してから /cart へリダイレクト
    document.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest('.shopify-payment-button__button, [data-go-to-cart-after-add]');
        if (!button) return;

        const section = button.closest(PRODUCT_INFORMATION_SELECTOR);
        if (!section) return;

        const selector = section.querySelector(GIFT_PAIRING_SELECTOR);
        if (!selector) return;

        const selectedGiftBox = getSelectedGiftBox(section, selector);
        const isTwoBottleBox = selectedGiftBox.type === 'two';

        if (!selectedGiftBox.type) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const selectedInput = selector.querySelector('[data-gift-pairing-input]:checked');
        if (isTwoBottleBox && !selectedInput) {
          window.alert('2本箱に入れるもう1本を選択してください。');
          return;
        }

        const currentTitle = selector.dataset.currentProductTitle || '';
        const selectedTitle = isTwoBottleBox ? selectedInput.dataset.productTitle || selectedInput.value || '' : '';
        const giftBoxVariantId = selectedGiftBox.variantId;
        const matchingGiftSet = isTwoBottleBox ? getMatchingGiftSet(selector, selectedInput) : null;

        if (!matchingGiftSet && !selectedGiftBox.variantId) {
          window.alert('ギフトボックス商品が設定されていません。');
          return;
        }

        button.setAttribute('aria-busy', 'true');
        button.disabled = true;

        const form = section.querySelector('form');
        const formData = new FormData(form);
        const setQty = isTwoBottleBox ? getSetQuantity(selector) : getFormQuantity(form);
        const giftPairingGroup = `gift-pairing-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        formData.set('quantity', String(setQty));
        formData.set('properties[_gift_pairing_group]', giftPairingGroup);
        formData.set('properties[_gift_pairing_role]', 'main');

        const addPromise = matchingGiftSet
          ? fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({
                items: [
                  {
                    id: parseInt(matchingGiftSet.dataset.giftSetVariantId, 10),
                    quantity: setQty,
                    properties: {
                      ギフトセット内容: `${currentTitle} + ${selectedTitle}`,
                      _gift_pairing_group: giftPairingGroup,
                      _gift_pairing_role: 'gift_set',
                    },
                  },
                ],
              }),
            }).then((res) => {
              if (!res.ok) throw new Error();
            })
          : fetch('/cart/add.js', {
              method: 'POST',
              body: formData,
            }).then((res) => {
          if (!res.ok) throw new Error();
          const pairingVariantId = isTwoBottleBox ? selectedInput.dataset.variantId : '';
          const additions = [];

          if (pairingVariantId) {
            additions.push({
              id: parseInt(pairingVariantId, 10),
              quantity: setQty,
              properties: {
                '2本箱の組み合わせ商品': currentTitle,
                _gift_pairing_group: giftPairingGroup,
                _gift_pairing_role: 'pairing',
              },
            });
          }

          if (giftBoxVariantId && !matchingGiftSet) {
            const giftBoxProperties = {
              _gift_pairing_group: giftPairingGroup,
              _gift_pairing_role: 'gift_box',
            };

            if (isTwoBottleBox) {
              giftBoxProperties['2本箱の組み合わせ商品'] = `${currentTitle} + ${selectedTitle}`;
            }

            additions.push({
              id: parseInt(giftBoxVariantId, 10),
              quantity: setQty,
              properties: giftBoxProperties,
            });
          }

          if (additions.length === 0) return;

          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: additions }),
          }).then((res2) => {
            if (!res2.ok) throw new Error();
          });
        });

        addPromise
          .then(() => {
            window.location.href = '/cart';
          })
          .catch((error) => {
            console.error(error);
            button.removeAttribute('aria-busy');
            button.disabled = false;
            window.alert('注文内容確認への移行に失敗しました。「カートに入れる」ボタンをご利用ください。');
          });
      },
      true
    );

    // bfcache から戻った際に disabled のままになるボタンをリセット
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      document
        .querySelectorAll('.shopify-payment-button__button[disabled], button[name="add"][disabled]')
        .forEach((btn) => {
          btn.removeAttribute('aria-busy');
          btn.disabled = false;
        });
    });

    document.addEventListener('quantity-selector:update', handleQuantityEvent);
    document.addEventListener('variant:update', scheduleUpdate);
    document.addEventListener('input', (event) => {
      const target = event.target;
      if (target instanceof HTMLInputElement && target.matches(QUANTITY_INPUT_SELECTOR)) {
        handleQuantityEvent(event);
      }

      // セット数量入力の変更
      if (target instanceof HTMLInputElement && target.matches('[data-gift-pairing-set-quantity]')) {
        const selector = target.closest(GIFT_PAIRING_SELECTOR);
        const section = target.closest(PRODUCT_INFORMATION_SELECTOR);

        if (selector) updateGiftPairingCalculation(selector);
        if (section) queueGiftPairingReady(section);
      }

      const section = target instanceof Element ? target.closest(PRODUCT_INFORMATION_SELECTOR) : null;
      if (section && target instanceof HTMLInputElement && target.type === 'radio') {
        updateSection(section);
      }
    });
    document.addEventListener('change', (event) => {
      const target = event.target;
      if (target instanceof HTMLInputElement && target.matches(QUANTITY_INPUT_SELECTOR)) {
        handleQuantityEvent(event);
      }

      const section = target instanceof Element ? target.closest(PRODUCT_INFORMATION_SELECTOR) : null;
      if (section && target instanceof HTMLInputElement && target.type === 'radio') {
        updateSection(section);
      }
    });

    const observer = new MutationObserver(() => scheduleUpdate());

    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleUpdate, { once: true });
    } else {
      scheduleUpdate();
    }
  })();

  (() => {
    const GIFT_PAGE_PATH = '/pages/wrapping';
    const dialog = document.getElementById('gift-info-dialog');
    if (!dialog) return;

    const contentEl = dialog.querySelector('.gift-info-dialog__content');
    let loaded = false;

    async function openGiftDialog() {
      dialog.showModal();
      document.body.style.overflow = 'hidden';
      if (loaded) return;
      contentEl.innerHTML = '<p class="gift-info-dialog__loading">読み込み中…</p>';
      try {
        const res = await fetch(GIFT_PAGE_PATH);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const main = doc.querySelector('main') || doc.body;
        contentEl.innerHTML = main.innerHTML;

        contentEl.querySelectorAll('[data-gift-card-slider]').forEach((slider) => {
          const slides = Array.from(slider.querySelectorAll('[data-gift-slider-slide]'));
          const dots = Array.from(slider.querySelectorAll('[data-gift-slider-dot]'));
          const prevButton = slider.querySelector('[data-gift-slider-prev]');
          const nextButton = slider.querySelector('[data-gift-slider-next]');
          if (slides.length <= 1) return;
          let currentIndex = slides.findIndex((s) => s.dataset.active === 'true');
          if (currentIndex < 0) currentIndex = 0;
          let isAnimating = false;
          const showSlide = (nextIndex) => {
            if (isAnimating) return;
            isAnimating = true;
            currentIndex = (nextIndex + slides.length) % slides.length;
            slides.forEach((slide, i) => {
              if (i === currentIndex) {
                slide.setAttribute('data-active', 'true');
              } else {
                slide.removeAttribute('data-active');
              }
            });
            dots.forEach((dot, i) => {
              if (i === currentIndex) {
                dot.setAttribute('aria-current', 'true');
              } else {
                dot.removeAttribute('aria-current');
              }
            });
            setTimeout(() => {
              isAnimating = false;
            }, 650);
          };
          prevButton?.addEventListener('click', () => showSlide(currentIndex - 1));
          nextButton?.addEventListener('click', () => showSlide(currentIndex + 1));
          dots.forEach((dot, i) => dot.addEventListener('click', () => showSlide(i)));
        });

        loaded = true;
      } catch {
        contentEl.innerHTML = '<p>読み込みに失敗しました。</p>';
      }
    }

    document.addEventListener('click', (e) => {
      const link = e.target.closest(`a[href="${GIFT_PAGE_PATH}"], a[href^="${GIFT_PAGE_PATH}?"]`);
      if (!link) return;
      e.preventDefault();
      openGiftDialog();
    });

    function closeGiftDialog() {
      dialog.close();
      document.body.style.overflow = '';
    }

    dialog.querySelector('.gift-info-dialog__close')?.addEventListener('click', closeGiftDialog);
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) closeGiftDialog();
    });
    dialog.addEventListener('close', () => {
      document.body.style.overflow = '';
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
